import React, { useMemo } from 'react';
import cn from 'classnames';

import Box from '../Box';
import { setGap, setGapX, setGapY } from './styles';
import { StackProps } from './types';
import {
  ALIGN_ITEMS_CLASSNAME,
  DIRECTION_CLASSNAME,
  joinChildren,
  JUSTIFY_CONTENT_CLASSNAME,
} from './utils';

const Stack = React.forwardRef<HTMLDivElement, StackProps>((props, ref) => {
  const {
    alignItems = 'stretch',
    children,
    className,
    direction = 'row',
    divider,
    gap,
    gapX,
    gapY,
    justifyContent = 'start',
    spacing,
    ...rest
  } = props;

  const directionClassname = DIRECTION_CLASSNAME[direction];
  const alignItemsClassname = ALIGN_ITEMS_CLASSNAME[alignItems];
  const justifyContentClassname = JUSTIFY_CONTENT_CLASSNAME[justifyContent];

  const modifiedChildren = useMemo(
    () => (divider ? joinChildren(children, divider) : children),
    [children, divider],
  );

  return (
    <Box
      ref={ref}
      className={cn(
        'flex',
        gap && setGap(gap),
        gapX && setGapX(gapX),
        gapY && setGapY(gapY),
        spacing,
        directionClassname,
        alignItemsClassname,
        justifyContentClassname,
        className,
      )}
      {...rest}>
      {modifiedChildren}
    </Box>
  );
});

Stack.displayName = 'Stack';

export default Stack;
